module.exports = __webpack_public_path__ + "img/benefit_home.a9ceab77.png";